import React from "react";
import styled from "styled-components";
import { Table, Container } from "react-bootstrap";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import ups from "./../../../assets/ups.png";

const Shipping = () => (
  <StyledShipping>
    <Container>
      <UnderlinedHeader text={"Shipping Options"} bolder />
      <p>We use following companies to deliver your goods:</p>
      <div>
        <p>1. UPS Standard</p>
        <figure>
          <img src={ups} alt={"UPS"} />
          <figcaption>
            *Image source: www.ups.com. The transit times reflect UPS' regular
            delivery schedule, but are not guaranteed
          </figcaption>
        </figure>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Country:</th>
              <th>UPS - Estimate lead time (working days)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Germany, Czech Republic, Slovakia</td>
              <td>2 days</td>
            </tr>
            <tr>
              <td>
                France, Belgium, Denmark, Netherlands, Austria, Switzerland
              </td>
              <td>3 days</td>
            </tr>
            <tr>
              <td>United Kingdom, Spain, Italy, Slovenia, Hungary, Romania</td>
              <td>4 days</td>
            </tr>
            <tr>
              <td>
                Portugal, Greece, Croatia, Lithuania, Latvia, Estonia, Norway
              </td>
              <td>5 days</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div style={{ margin: "20px 0" }}>
        2. UPS Express (1-2 days over continental Europe) - Orders placed online
        and paid till 1:00 pm are being processed the same day
      </div>

      <div>
        <p>3. DPD</p>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th style={{ width: "50%" }}>Kraj:</th>
              <th>DPD - Szacunkowy czas realizacji zamówienia (dni robocze)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Belgium</td>
              <td>3 days</td>
            </tr>
            <tr>
              <td>Bulgaria</td>
              <td>5 days</td>
            </tr>
            <tr>
              <td>Czech Republic</td>
              <td>3 days</td>
            </tr>
            <tr>
              <td>Finland</td>
              <td>5 days</td>
            </tr>
            <tr>
              <td>France</td>
              <td>4 days</td>
            </tr>
            <tr>
              <td>Germany</td>
              <td>3 days</td>
            </tr>
            <tr>
              <td>Greece</td>
              <td>6 days</td>
            </tr>
            <tr>
              <td>Italy</td>
              <td>5 days</td>
            </tr>
            <tr>
              <td>Netherlands</td>
              <td>3 days</td>
            </tr>
            <tr>
              <td>Poland</td>
              <td>1 day</td>
            </tr>
            <tr>
              <td>Portugal</td>
              <td>5 days</td>
            </tr>
            <tr>
              <td>Romania</td>
              <td>4 days</td>
            </tr>
            <tr>
              <td>Spain</td>
              <td>5 days</td>
            </tr>
            <tr>
              <td>Sweden</td>
              <td>4 days</td>
            </tr>
          </tbody>
        </Table>
      </div>
      <div>
        <p>
          <strong>
            *Given number of days does not include the day of the dispatch.
          </strong>
        </p>
      </div>
    </Container>
  </StyledShipping>
);

export default Shipping;

const StyledShipping = styled.section`
  padding-top: 92px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
`;
